<template>
	<div id="disclosure-statement">
		<p><strong>NOTICE:</strong></p>
		<p>
			The information contained in this webpage and any files hereto are intended for the exclusive use of the
			addressee(s) and may contain confidential, proprietary and/or privileged information. If you are not the
			intended recipient please notify the sender immediately, do not copy or disclose this proprietary link
			with anyone and destroy all information obtained from this webpage and any files you may have downloaded.
		</p>
	</div>
</template>
<script>

export default {
  name: 'DisclosureStatement'
}
</script>
<style lang="scss" scoped>
#disclosure-statement {
  margin: 10px 0 20px;
  padding: 15px 30px 15px 20px;
  font-size: 85%;
  line-height: 22px;
  background-color: #fff;
  border: 1px solid red;
  border-radius: 5px;

  strong {
    color: red;
    font-size: 1.2em;
  }

  p {
    margin-bottom: 3px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Account/DisclosureStatement.vue